<template>
  <div class="card my-4">
    <div class="card-header d-flex justify-content-between align-items-center bg-primary text-white">
      <h6 class="mb-0">Performance</h6>
      <select class="form-control w-auto" v-model="filterType" @change="$emit('changePeriod', filterType)">
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
      </select>
    </div>
    <div class="card-body">
      <!-- Apex Chart -->
      <apexchart type="line" height="300" :options="chartOptions" :series="series" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PerformanceChart",
  props: ["filterType", 'data'],
  data() {
    return {
      series: [
        {
          name: "Points",
          data: [20, 50, 25, 60, 80, 50, 55], // dummy data
        },
      ],
      chartOptions: {
        chart: {
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        stroke: {
          curve: "smooth",
          width: 5,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.8,
            opacityTo: 0.6,
          },
        },
        markers: {
          size: 4,
          colors: ["#007bff"],
          strokeColors: "#fff",
          strokeWidth: 2,
        },
        colors: ["#007bff"],
      },
    };
  },
};
</script>
